import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="w-full bg-white" aria-label="Hero">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            {/* Badge */}
            <div className="inline-block">
              <span className="px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
                The #1 Badminton Score Tracker & AI Coach
              </span>
            </div>

            {/* Heading - SEO optimized */}
            <div>
              <h1 className="text-5xl sm:text-6xl font-bold text-gray-900 leading-tight">
                Track your path to{' '}
                <span className="text-blue-600">Victory</span>
              </h1>
              <h2 className="text-base lg:text-lg text-gray-600 mt-4 leading-relaxed">
                AI-powered badminton match tracker, video coaching, and training diary for players of all levels
              </h2>
            </div>

            {/* Description */}
            <p className="text-base text-gray-600 leading-relaxed">
              Log matches, analyze your technique with AI video coaching, track what you learn in every session, and visualize your progress with professional-grade statistics tailored for badminton players.
            </p>

            {/* CTA Buttons */}
            <div className="flex items-center gap-4">
              <Button 
                onClick={() => navigate('/signup')}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-6 text-base font-medium transition-all hover:shadow-lg"
                data-testid="hero-get-started-btn"
              >
                Get Started Free
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </div>

            {/* Trust signals */}
            <div className="flex items-center gap-6 text-sm text-gray-500">
              <span>Free forever</span>
              <span>Works offline</span>
              <span>AI-powered</span>
            </div>
          </div>

          {/* Right Content - Image with Achievement Badge */}
          <div className="relative">
            <img
              src="https://customer-assets.emergentagent.com/job_blog-56/artifacts/t9r4zuiv_Racket_Guide_Web_Banner_16-9.jpeg"
              alt="Badminton player performing a smash shot during competitive match - track your badminton stats and improve"
              className="w-full h-auto rounded-2xl shadow-lg"
              loading="eager"
            />
            
            {/* Achievement Badge */}
            <div className="absolute -left-4 lg:-left-8 bottom-8 bg-white rounded-xl shadow-2xl p-5 border border-gray-100 animate-in fade-in slide-in-from-left duration-700">
              <p className="text-xs text-gray-500 font-medium mb-1">Recent Achievement</p>
              <p className="text-xl font-bold text-gray-900">5 Win Streak</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
